import React, { useEffect, useState } from "react";
import Parser from "html-react-parser";
import { useSelector } from "react-redux";
//import { useHistory } from "react-router-dom";
import { animations } from "react-animation";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./Productos.css";

const root = process.env.REACT_APP_CMS_STATIC;

function ProductosAhorroCredito(props) {
  //let history = useHistory();
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");
  const isXSmall = useMediaQuery("(max-width: 374px)");
  const [products, setProducts] = useState([]);

  const { productos } = useSelector(({ Base }) => Base.ContenidoCMS);

  useEffect(() => {
    setProducts(productos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productos]);

  //Styles
  const contenedorStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "d-flex flex-wrap flex-column justify-content-center";
    }
    if (isIphoneX) {
      cls =
        "contenedortablet-productos d-flex flex-wrap justify-content-around";
    }
    if (isIpadPortrait) {
      cls =
        "contenedortablet-productos d-flex flex-wrap justify-content-around";
    }
    if (isIpadLandscape) {
      cls =
        "contenedortablet-productos d-flex flex-wrap justify-content-around";
    }
    if (isMidLaptop) {
      cls = "d-flex flex-wrap justify-content-around";
    }
    if (isFullHD) {
      cls = "contenedordesktop-productos d-flex justify-content-between";
    }
    if (is4K) {
      cls = "contenedor-productos d-flex justify-content-between";
    }
    return cls;
  };

  return (
    <div className="container-products">
      <div
        className={contenedorStyle()}
        style={{ animation: animations.fadeIn }}
      >
        {products &&
          products.map((prod, index) => {
            return (
              <a
                key={index}
                className="product-card"
                href={prod?.url?.url ? prod.url.url : "#"}
              >
                <div>
                  <img
                    className="product-card-image"
                    src={root + prod.imagen.urls[0]}
                    alt={Parser(prod.displayText)}
                  />
                </div>
                <h2>
                  <div className="product-card-title">
                    {Parser(prod.displayText)}
                  </div>
                </h2>
                <div className="product-card-texto">
                  {Parser(prod.descripcion.html)}
                </div>
              </a>
            );
          })}
      </div>
    </div>
  );
}

export default ProductosAhorroCredito;
